import { LanguagesEnum } from '@/api/enums';
import {
  InteractiveElementType,
  Slide,
  SlideTemplateType,
  TextAlignment,
} from '@/client/courses/types/courses.type';
import { ContentEmailComponent } from '@/components/courses/elements/ContentEmailComponent';
import { ContentSMSComponent } from '@/components/courses/elements/ContentSMSComponent';
import { SlideImageComponent } from '@/components/slides/elements/SlideImageComponent';
import { FlexContainer } from '@/ui/styled-ui';
import { filterSlideImagesByTemplate } from '@/utils/helpers/courses.helper';
import { isRtlLanguage } from '@/utils/helpers/language.helper';
import React from 'react';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';
import { RichTextArea } from './RichTextArea';
import { RichTextTitle } from './RichTextTitle';

const SlideImagePreview = styled.div`
  width: 300px !important;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;

  .p-image {
    height: 100%;
    display: flex;
  }

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  button {
    border-radius: var(--medium-border-radius);
  }
`;
interface ChapterFormProps {
  currentEditingSlide: Slide;
  currentSlideData: Slide;
  selectedLanguage: string;
  isEditingPopUpSlide: boolean;
  currentSlideIdx: number;
  totalSlides: number;
  updateSlide: (id: string, updates: Partial<Slide>) => void;
}

export const ChapterForm: React.FC<ChapterFormProps> = ({
  currentEditingSlide,
  updateSlide,
  selectedLanguage,
  isEditingPopUpSlide,
  currentSlideIdx,
  currentSlideData,
}) => {
  return (
    <FlexContainer
      gap={22}
      justify="space-between"
      align="center"
      height="100%"
    >
      <div style={{ flexGrow: 1 }}>
        <RichTextTitle
          currentEditingSlide={currentEditingSlide}
          isEditingPopUpSlide={isEditingPopUpSlide}
          currentSlideData={currentSlideData}
          updateSlide={updateSlide}
        />

        <RichTextArea
          currentEditingSlide={currentEditingSlide}
          isEditingPopUpSlide={isEditingPopUpSlide}
          selectedLanguage={selectedLanguage}
          currentSlideIdx={currentSlideIdx}
          currentSlideData={currentSlideData}
          updateSlide={updateSlide}
        />
      </div>

      {currentSlideData.interactiveElement ? (
        currentSlideData.interactiveElement.type ===
        InteractiveElementType.EMAIL ? (
          <ContentEmailComponent
            id={currentSlideData.id}
            interactiveElement={currentSlideData.interactiveElement}
            onUpdate={(data) => {
              if (currentEditingSlide?.id) {
                updateSlide(currentEditingSlide.id, {
                  interactiveElement: {
                    ...currentSlideData.interactiveElement,
                    data,
                  },
                });
              }
            }}
          />
        ) : currentSlideData.interactiveElement.type ===
          InteractiveElementType.SMS ? (
          <ContentSMSComponent
            id={currentSlideData.id}
            interactiveElement={currentSlideData.interactiveElement}
            rtl={isRtlLanguage(selectedLanguage as LanguagesEnum)}
            onUpdate={(data) => {
              if (currentEditingSlide?.id) {
                updateSlide(currentEditingSlide.id, {
                  interactiveElement: {
                    ...currentSlideData.interactiveElement,
                    data,
                  },
                });
              }
            }}
          />
        ) : null
      ) : (
        filterSlideImagesByTemplate(
          currentSlideData.images,
          currentSlideData.templateType,
          SlideTemplateType.GALLERY,
        )?.map((image, index) => (
          <SlideImagePreview key={index}>
            <SlideImageComponent
              key={index}
              image={image}
              currentEditingSlide={currentEditingSlide}
              updateSlide={updateSlide}
              textAlignment={
                currentSlideData.textAlignment || TextAlignment.LEFT
              }
              isGallery={true}
            />
          </SlideImagePreview>
        ))
      )}
    </FlexContainer>
  );
};
